import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Float } from './../../../functions/input-float';
import { getConsiderProductPriceByTypePrice } from '../../../functions/app';
import { DeleteOutlined } from '@ant-design/icons';
import { InputQty } from './shopModal';

class ProductLine extends Component {
    constructor(props) {
        super(props);
        this.qty_minus = this.qty_minus.bind(this);
        this.qty_plus = this.qty_plus.bind(this);
        this.qty_body_OnChange = this.qty_body_OnChange.bind(this);
        this.qty_body_OnBlur = this.qty_body_OnBlur.bind(this);
        this.qty_body_OnClick = this.qty_body_OnBlur.bind(this);
        this.destroy = this.destroy.bind(this);
    }

    qty_plus() {
        let props = this.props;
        props.setProductQty(props.product.id, props.product.qty + 1);
    }

    qty_minus(e) {
        let props = this.props;
        e.stopPropagation();
        Number(props.product.qty) - 1 <= 0
            ? props.destroyProduct(props.product.id)
            : props.setProductQty(props.product.id, props.product.qty - 1);
    }

    qty_body_OnChange(e) {
        let props = this.props;
        e.stopPropagation();
        props.setProductQty(props.product.id, Float(e.target.value, 3));
    }

    qty_body_OnBlur(e) {
        let props = this.props;
        e.stopPropagation();
        if (e.target.value <= 0) {
            props.destroyProduct(props.product.id);
        }
    }

    qty_body_OnClick(e) {
        e.stopPropagation();
    }

    destroy(e) {
        let props = this.props;
        e.stopPropagation();
        props.destroyProduct(props.product.id);
    }

    render() {
        let props = this.props,
            product = props.product,
            src = props.route,
            img = 'no-foto.png',
            price = getConsiderProductPriceByTypePrice(
                product,
                props.point.type_price_json,
                product.qty,
                props.user ? props.user.discount : 0
            ).price_consider;
        if (product.image) {
            src += 'api/shop/images/small/';
            img = product.image.split('.jpg').join('');
        } else {
            src += 'img/';
        }
        return (
            <div className="product-row">
                <div className="product-line-img">
                    <img alt="" src={src + img} />
                </div>
                <div className={'product-row__info'}>
                    <div className={'product-row__description'}>
                        <div
                            className="product-line-name"
                            style={{
                                color: props.setting.rightModal.body
                                    .secondColor,
                            }}
                        >
                            <div className={'product-row__text'}>
                                {product.name}
                                <span
                                    className="price"
                                    style={{
                                        color: props.setting.rightModal.body
                                            .priceColor,
                                    }}
                                >
                                    {price} {props.currency}
                                </span>
                            </div>
                        </div>
                        <div className="product-line-destroy">
                            <div
                                className="product-line-destroy-body"
                                style={{
                                    color: props.setting.rightModal.body.color,
                                }}
                                onClick={this.destroy}
                            >
                                <DeleteOutlined />
                            </div>
                        </div>
                    </div>
                    <div className={'product-row__prices'}>
                        <InputQty
                            style={{
                                background:
                                    props.setting.rightModal.body.input
                                        .background,
                                color: props.setting.rightModal.body.input
                                    .color,
                                borderColor:
                                    props.setting.rightModal.body.input
                                        .borderColor,
                            }}
                            value={product.qty}
                            onChange={this.qty_body_OnChange}
                            onBlur={this.qty_body_OnBlur}
                            onClick={this.qty_body_OnClick}
                            plusStyle={{
                                color: props.setting.rightModal.body.color,
                            }}
                            onMinus={this.qty_minus}
                            onPlus={this.qty_plus}
                        />
                        <div
                            className="product-line-price"
                            style={{
                                color: props.setting.rightModal.body
                                    .secondColor,
                            }}
                        >
                            {Float(price * product.qty)} {props.currency}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = function mapStateToProps(state) {
    return {
        route: state.appState.route,
        setting: state.appState.setting,
        user: state.authState.user,
        currency: state.pointsState.currency,
        shopCase: state.shopState.shopCase,
        point: state.shopState.order.point,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        destroyProduct: function (product_id) {
            dispatch({
                type: 'destroy_product',
                product_id: product_id,
            });
        },
        setProductQty: function (product_id, qty) {
            dispatch({
                type: 'set_product_qty',
                product_id: product_id,
                qty: qty,
            });
        },
        dispatch,
    };
};

export const ProductLineLink = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductLine);
